import { render, staticRenderFns } from "./registreren.vue?vue&type=template&id=fde36a50&"
import script from "./registreren.vue?vue&type=script&lang=js&"
export * from "./registreren.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports